// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <div>Loading...</div>; // Optional loading screen while checking auth
  }

  if (!user) {
    return <Navigate to="/" />; // Redirect to login page if not authenticated
  }

  return children;
}

export default ProtectedRoute;